import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SettingsRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--pf-canvas)]">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-4 border-[var(--pf-accent)]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'admin') return <Navigate to="/admin-settings" replace />;
  if (user.role === 'caregiver') return <Navigate to="/caregiver-settings" replace />;
  return <Navigate to="/owner-settings" replace />;
};

export default SettingsRedirect;
